import { TemplateResult, html, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './tufts-card-icon-callout.css.lit';
import tuftsStyledText from '../tufts-styled-text/tufts-styled-text.css.lit';
import tuftsSearchBar from '../tufts-search-bar/tufts-search-bar.css.lit';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import { tuftsCard } from '../tufts-card/tufts-card';

/**
 * The Tufts Card Icon Callout component
 * @element tufts-card-icon-callout
 *
 * @slot icon
 * @slot heading
 * @slot description
 * @slot cta
 */
@customElement('tufts-card-icon-callout')
export class tuftsCardIconCallout extends tuftsCard {
  static styles: CSSResultGroup = [
    componentStyles,
    tuftsStyledText,
    tuftsSearchBar,
    tuftsHeadingCssLit,
  ];

  @property({ type: String, reflect: true, attribute: 'background' })
  background = 'transparent';

  firstUpdated(): void {
    this.checkParentNodeContainer();
  }
  // TODO Alfredo clear this when removing the button icon-type css
  ctaTemplate1(slotName: string, theme: string): TemplateResult | null {
    if (this.ngSlot.exist(slotName)) {
      return html`
        <tufts-button
          class="${slotName}"
          button-variant="${theme === 'theme-light' ? 'primary' : 'reversed'}"
        >
          ${this.ngSlot.renderInShadow(slotName)}
        </tufts-button>
      `;
    }
    return null;
  }

  render(): TemplateResult {
    const classes = {
      'card-icon-callout': true,
      'mobile': this.resizeController.currentBreakpointRange === 0,
    };
    return html`
      <article class="${classMap(classes)}">
        <div class="main-wrapper">
          ${this.ngSlot.conditionalNGSlot('icon')}
          ${this.ngSlot.conditionalNGSlot('heading', true, 'md')}
          ${this.ngSlot.conditionalNGSlot('description')}
        </div>
        ${this.ctaTemplate1('cta', this.setColorTemplate())}
      </article>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-card-icon-callout': tuftsCardIconCallout;
  }
}
